const colors = {
  mediumBlue: '#0190fe',
  brightGreen: '#52c41a',
  orange: '#fa8c16',
  brightRed: '#ff0000',
  lightRed: '#ff8181',
  grey: '#8c8c8c',
  purple: '#bfa2c8',
  lightgrey: '#ababab',
  black: '#000',
  darkGreen: '#008e00',
  mediumGreen: '#D3E9C6',
  mediumOrange: '#FFE0B2',
  yellow: '#FFF4CC',
};

export default colors;
